<template>
    <settings-page :title="title" :description="description">
        <div class="gradients">
            <transition-group
                name="gradients"
                tag="ul"
                class="gradients__list"
            >
                <li
                    v-for="(gradient, gradientIndex) in gradients"
                    :key="gradient.name"
                    class="gradients__item"
                >
                    <gradient
                        :index="gradientIndex"
                        :gradient="gradient"
                        @input="onUpdateGradient"
                    />
                </li>
            </transition-group>

            <div v-if="gradients.length < MAX_GRADIENTS" class="gradients__button" @click="onAddGradient">
                <font-awesome-icon
                    class="gradients__button-icon"
                    size="2x"
                    :icon="['fal', 'plus']"
                />
                <div class="gradients__button-text">ADD PRESET</div>
            </div>
        </div>
    </settings-page>
</template>

<script>
import { mapState } from 'vuex';

import SettingsPage from '@/components/settings/shared/settings-page';
import Gradient from '@/components/settings/color/settings-gradient';

export default {
    name: 'settings-gradients',
    components: { SettingsPage, Gradient },

    data() {
        return {
            title: 'Gradients',
            MAX_GRADIENTS: 20,
        };
    },

    computed: {
        ...mapState({
            settings: state => state.settings,
        }),

        description() {
            return `You may add up to ${ this.MAX_GRADIENTS } custom gradients. Each gradient supports up to 5 color stops. To adjust the color stop percentage, simply drag the slider left or right.`;
        },

        gradients() {
            if (!this.settings) return [];

            return this.settings.gradients;
        },
    },

    methods: {
        onAddGradient() {
            this.gradients.push({
                name: `gradient-${ this.gradients.length + 1 }`,
                displayName: `Gradient ${ this.gradients.length + 1 }`,
                type: 'linear',
                direction: '90',
                points: [
                    {
                        position: '0%',
                        color: '#333',
                    },

                    {
                        position: '100%',
                        color: '#f1f1f1',
                    },
                ],
            });
        },

        onUpdateGradient(index, gradient) {
            this.gradients[index] = gradient;

            this.$emit('input', 'gradients', this.gradients);
        },
    },
};
</script>

<style lang="scss">
.gradients {
    &-enter,
    &-leave-to {
        opacity: 0;
        transform: translateX(-100px);
    }

    &-leave-active {
        position: absolute;
    }

    &__item {
        &:not(:first-of-type) {
            margin-top: 25px;
        }
    }

    &__button {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 72px;
        height: 72px;
        margin: 30px 0 20px;
        border: dashed 2px var(--app-color);
        color: var(--app-color);
        transition: all 0.33s;

        &:hover {
            cursor: pointer;
        }
    }

    &__button-icon {
        width: 24px;
        margin-bottom: 5px;
        margin-top: 4px;
        opacity: 0.9;
    }

    &__button-text {
        font-size: 11px;
        position: absolute;
        bottom: -30px;
        left: 0;
        right: 0;
        font-weight: 700;
        white-space: nowrap;
        margin-left: -100%;
        margin-right: -100%;
        text-align: center;
    }
}
</style>
